var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

export var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

export default placements;


//////////////////
// WEBPACK FOOTER
// ./~/rc-menu/es/placements.js
// module id = 159
// module chunks = 0 1 2 3